var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhysicalstatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.16,
    height: 20,
    viewBox: "0 0 19.16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12664",
    "data-name": "Group 12664",
    transform: "translate(486.067 99.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4556",
    "data-name": "Path 4556",
    d: "M-414.634-63.132a12.181,12.181,0,0,1,1.147-5.113,6.517,6.517,0,0,1,3.578-3.365,7.5,7.5,0,0,1,3.411-.408,6.381,6.381,0,0,1,3.552,1.425,7.494,7.494,0,0,1,2.283,3.446,12.92,12.92,0,0,1,.628,5.5,10.053,10.053,0,0,1-2.406,5.732,6.885,6.885,0,0,1-3.778,2.38A5.292,5.292,0,0,1-410.1-54.2a8.876,8.876,0,0,1-3.81-4.652A10.874,10.874,0,0,1-414.634-63.132Zm10.523,1.505a2.227,2.227,0,0,0,1.518-.533,1.288,1.288,0,0,0,.065-1.969,2.389,2.389,0,0,0-3.173,0,1.291,1.291,0,0,0,.088,1.983A2.246,2.246,0,0,0-404.11-61.627Zm-6.16,0a2.144,2.144,0,0,0,1.195-.444,1.312,1.312,0,0,0,.279-1.948,2.373,2.373,0,0,0-3.395.013,1.27,1.27,0,0,0,.1,1.76A2.365,2.365,0,0,0-410.27-61.625Zm2.955,5.171c.2-.019.394-.026.588-.058a2.892,2.892,0,0,0,1.622-.84c.176-.177.191-.385.01-.513-.384-.271-.777-.532-1.184-.766a.86.86,0,0,0-.87,0,.339.339,0,0,1-.277.012,1.013,1.013,0,0,0-1.081.072c-.32.19-.624.408-.928.625-.256.183-.263.367-.036.592A3.012,3.012,0,0,0-407.315-56.454Zm.013-3.786a1.745,1.745,0,0,0,.939-.338c.241-.182.291-.321.174-.466s-.235-.114-.476.061a.976.976,0,0,1-1.283-.007c-.034-.025-.064-.055-.1-.08a.243.243,0,0,0-.359.021.241.241,0,0,0,.035.358A1.724,1.724,0,0,0-407.3-60.24Z",
    transform: "translate(-68.404 -25.842)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4557",
    "data-name": "Path 4557",
    d: "M-95.978,310.987c-.124.146-.193.3-.308.351a1.527,1.527,0,0,0-.741.741.386.386,0,0,1-.718,0,1.542,1.542,0,0,0-.739-.741.385.385,0,0,1,0-.717,1.541,1.541,0,0,0,.741-.74.385.385,0,0,1,.717,0,1.537,1.537,0,0,0,.739.743C-96.171,310.681-96.1,310.838-95.978,310.987Z",
    transform: "translate(-370.93 -391.369)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M-484.728-40.926c.149.124.3.195.362.313a1.5,1.5,0,0,0,.727.725.39.39,0,0,1,.008.731,1.547,1.547,0,0,0-.737.74.387.387,0,0,1-.719-.008,1.514,1.514,0,0,0-.741-.739.384.384,0,0,1-.009-.708,1.539,1.539,0,0,0,.757-.752C-485.026-40.736-484.875-40.8-484.728-40.926Z",
    transform: "translate(0 -55.656)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4559",
    "data-name": "Path 4559",
    d: "M-426-97.245c-.1-.094-.208-.15-.251-.237a.943.943,0,0,0-.437-.434.261.261,0,0,1,0-.5.991.991,0,0,0,.436-.434c.135-.26.375-.257.512.006a.952.952,0,0,0,.421.419c.263.139.265.377,0,.513a.972.972,0,0,0-.435.436C-425.8-97.4-425.9-97.342-426-97.245Z",
    transform: "translate(-56.679 0)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4560",
    "data-name": "Path 4560",
    d: "M-263.133,261.011c.218,0,.436,0,.654,0,.194,0,.315.107.318.263a.282.282,0,0,1-.311.274q-.654.008-1.308,0c-.2,0-.316-.115-.3-.276.015-.189.136-.264.317-.262C-263.555,261.012-263.344,261.011-263.133,261.011Z",
    transform: "translate(-212.58 -344.801)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalstatusIcon);
export default __webpack_public_path__ + "static/media/physicalstatusIcon.445cd1296611d11c639ea03c72040c88.svg";
export { ForwardRef as ReactComponent };